import { Component, OnInit, OnDestroy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TaxonomyService } from '../_services/taxonomy.service';
import { CartService } from '../_services/cart.service';
import { WishlistService } from '../_services/wishlist.service';
import { StoreService } from '../_services/store.service';
import { Offer, getPrice } from '../_models/offer';
import { environment } from '../../environments/environment';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { AppConstants } from '../_constants/constants';

@Component({
    selector: 'app-market-bag',
    templateUrl: './market-bag.component.html',
    styleUrls: ['./market-bag.component.css'],
    standalone: false
})
export class MarketBagComponent implements OnInit, OnDestroy {
    offers: Offer[] = [];
    config: any;
    page = 1;
    loading = true;
    lang = 'fr';
    private subs: Subscription[] = [];

    constructor(
        private taxonomyService: TaxonomyService,
        private cartService: CartService,
        private wishlistService: WishlistService,
        private storeService: StoreService,
        private toastrService: ToastrService,
        private translateService: TranslateService,
        private titleService: Title
    ) {}

    ngOnInit(): void {
        this.lang = localStorage.getItem(AppConstants.CURRENT_LANG_STORE_KEY) || this.translateService.getDefaultLang() || 'fr';
        this.subs.push(this.translateService.onLangChange.subscribe((event: any) => {
            this.lang = event.lang;
            this.titleService.setTitle(this.translateService.instant('market_bag.page_title'));
        }));
        this.titleService.setTitle(this.translateService.instant('market_bag.page_title'));
        this.loadProducts();
    }

    loadProducts(): void {
        this.loading = true;
        this.subs.push(this.taxonomyService.getTaxonomyOffers(5, this.page, 12).subscribe({
            next: (result: any) => {
                this.offers = result.data;
                this.config = {
                    totalItems: result.totalOfItems,
                    itemsPerPage: result.itemPerPage,
                    currentPage: result.page,
                    totalOfPage: result.totalOfPage
                };
                this.loading = false;
            },
            error: () => { this.loading = false; }
        }));
    }

    pageChange(page: number): void {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.page = page;
        this.loadProducts();
    }

    getImageSrc(offer: Offer): string {
        const picture = offer.defaultPicture?.length > 0 ? offer.defaultPicture : offer.product?.picture;
        return picture ? `${environment.image_cdn_url}/${picture}?func=crop&width=280&height=280` : '/assets/images/default.jpg';
    }

    getOfferPrice(offer: Offer): number { return getPrice(offer); }

    isOfferInCart(offer: Offer): boolean {
        return !!this.storeService.findItem(offer.id);
    }

    addToCart(offer: Offer): void {
        this.cartService.addToLocalCart(offer).subscribe(() => {
            const msg = this.translateService.get('common.message_for_added_to_cart')
                .subscribe(message => this.toastrService.success(message));
            this.subs.push(msg);
        });
    }

    addToWishlist(offerId: number): void {
        this.wishlistService.addToWishList(0, offerId).subscribe({
            next: () => this.toastrService.success('Added to wishlist'),
            error: () => this.toastrService.error('Already in wishlist')
        });
    }

    ngOnDestroy(): void { this.subs.forEach(s => s.unsubscribe()); }
}
